import { Component, computed, input, output, signal, OnInit } from '@angular/core';

import { IconsComponent } from '../icons/icons.component';
import {ToastConfig, ToastVariant} from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [IconsComponent],
  templateUrl: './toast.component.html'
})
export class ToastComponent implements OnInit {
  config = input.required<ToastConfig>();
  close = output<void>();

  isVisible = signal(false);

  ngOnInit(): void {
    // Trigger animation on mount
    setTimeout(() => this.isVisible.set(true), 10);

    // Auto-close if duration is set
    if (this.config().options.duration > 0) {
      setTimeout(() => {
        this.onClose();
      }, this.config().options.duration);
    }
  }

  onClose(): void {
    this.isVisible.set(false);
    setTimeout(() => this.close.emit(), 300);
  }

  toastClasses = computed(() => {
    const baseClasses = 'flex items-center p-4 text-sm rounded-base transition-all duration-300 shadow-lg min-w-[300px] max-w-md';

    const variantClasses: Record<ToastVariant, string> = {
      notice: 'text-blue-800 bg-blue-50',
      error: 'text-fg-danger-strong bg-danger-soft',
      success: 'text-fg-success-strong bg-success-soft',
      warning: 'text-fg-warning bg-warning-soft'
    };

    const visibilityClass = this.isVisible() ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0';

    return `${baseClasses} ${variantClasses[this.config().variant]} ${visibilityClass}`;
  });

  buttonClasses = computed(() => {
    const baseClasses = 'ms-auto -mx-1.5 -my-1.5 rounded focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 shrink-0 cursor-pointer text-black!';

    const variantClasses: Record<ToastVariant, string> = {
      notice: 'focus:ring-blue-400 hover:bg-blue-100',
      error: 'bg-danger-soft text-fg-danger-strong focus:ring-danger-medium hover:bg-danger-medium',
      success: 'focus:ring-success-medium hover:bg-success-medium',
      warning: 'focus:ring-warning-medium hover:bg-warning-medium'
    };

    return `${baseClasses} ${variantClasses[this.config().variant]}`;
  });

  defaultIcon = computed(() => {
    const icons: Record<ToastVariant, string> = {
      notice: 'info-circle',
      error: 'do-not-enter',
      success: 'circle-check',
      warning: 'circle-exclamation'
    };

    return icons[this.config().variant];
  });
}
